module.exports = __webpack_public_path__ + "946f7f9cf648144d52d3895fd7800e6c.png";